// カート追加ポップアップ通知
function showCartNotification() {
  const popup = document.getElementById('cartNotificationPopup');
  if (popup) {
    popup.classList.add('show');
    
    // 3秒後に自動で非表示
    setTimeout(() => {
      hideCartNotification();
    }, 3000);
  }
}

function hideCartNotification() {
  const popup = document.getElementById('cartNotificationPopup');
  if (popup) {
    popup.classList.remove('show');
  }
}

// カート追加イベントをリッスン
document.addEventListener('DOMContentLoaded', function() {
  // カートに追加するフォームを監視
  const cartForms = document.querySelectorAll('form[action*="/cart/add"]');
  
  cartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // ポップアップ通知を表示
        showCartNotification();
        
        // カートアイコンの数量を更新（テーマによって異なる）
        if (window.theme && window.theme.cart) {
          window.theme.cart.getCart();
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  });
});
